// extracted by mini-css-extract-plugin
export default {"loadingClock":"loader_loadingClock__34Fjk","rotate":"loader_rotate__PZK3t","loadingText":"loader_loadingText__sEt42"};